import { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';

/**
 * Instante em que a impressão foi disparada — `null` até lá.
 *
 * Não é `new Date()` no render: isso divergiria entre SSR e cliente
 * (hydration mismatch) e registraria a hora em que a página CARREGOU, não a da
 * impressão. `beforeprint` cobre os dois caminhos de disparo: o botão Imprimir
 * (`usePrintPage` → `window.print()`) e o Ctrl+P do navegador.
 */
export const usePrintTimestamp = (): Date | null => {
  const [printedAt, setPrintedAt] = useState<Date | null>(null);

  useEffect(() => {
    const handleBeforePrint = () => {
      /* Sem `flushSync`, o batching do React 18 pode adiar o commit para
         depois de o navegador capturar o layout de impressão, e a data sai
         em branco no papel. */
      flushSync(() => setPrintedAt(new Date()));
    };

    window.addEventListener('beforeprint', handleBeforePrint);
    return () => window.removeEventListener('beforeprint', handleBeforePrint);
  }, []);

  return printedAt;
};

export default usePrintTimestamp;
